import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Grid,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useOrganization } from "../../configurations/OrganizationContext";
import { format, parseISO } from "date-fns";
import patientActions from "../../core/actions/patientActions";
import { Alert } from "@mui/material";
import { Constants } from "ag-grid-community";
import { ERP_LABEL_INTERNAL_STATUS_MOVED_TO_BILLING } from "../../core/constants/erpConstants";
import { utcToZonedTime } from "date-fns-tz";

function MoveToBilling(props) {
  const dispatch = useDispatch();
  const org = useOrganization();
  const [aadharValue, setAadharValue] = useState("");
  const [aadharError, setAadharError] = useState("");
  const [visitList, setVisitList] = useState(props.visitList);
  const [onModal, setOnModal] = useState(props.open);
  const todayDate = format(new Date(), "yyyy-MM-dd");
  const currentTime = format(new Date(), "HH:mm");
  const [selecteddate, setSelecteddate] = useState(todayDate);
  const [selectedTime, setSelectedTime] = useState(currentTime);
  const [dischargeDate, setDischargeDate] = useState();
  const [dischargeTime, setDischargeTime] = useState();
  const [dischargeDateSelect, setDischargeDateSelect] = useState();
  const [roomDealocateModal, setRoomDealocateModal] = useState(false);
  const [showDependent, setShowDependent] = useState(false);
  const [dependentMname, setDependentMname] = useState("");
  const [dependentsCount, setDependentsCount] = useState(0);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDeallocating, setIsDeallocating] = useState(false);

  useEffect(() => {
    console.log("props in MoveToBilling", props);
    console.log("move to bill method:", visitList);
    // setAadharValue(visitList?.maskAdhar || "");
    setAadharError("");

    if (visitList?.visit?.dischargeDate) {
      const dischargeDateStr = visitList?.visit?.dischargeDate;

      if (dischargeDateStr) {
        const timeZone = "Asia/Kolkata";
        const utcDate = parseISO(dischargeDateStr);
        const istDate = utcToZonedTime(utcDate, timeZone);

        const localDate = format(istDate, "yyyy-MM-dd");
        const localTime = format(istDate, "HH:mm");

        setDischargeDate(localDate);
        setDischargeTime(localTime);

        if (localDate !== "" && localDate !== undefined) {
          setDischargeDateSelect(true);
        }
      }
    }
  }, []);

  useEffect(() => {
  if (props.openRoomDealocate) {
    setOnModal(false);            
    setRoomDealocateModal(true);  
  }
}, [props.openRoomDealocate]);

  const handleMoveToBilling = () => {
    updatePatientAadhar(visitList);
  };

  // added on 18-04-2025 for dependent flow
  const checkFordependent = (visitList) => {
    console.log("check dependent visitlist", visitList);
    setDependentMname(visitList.fname);
    return new Promise((resolve, reject) => {
      dispatch(
        patientActions.dependentCheck(
          visitList.id,
          visitList?.visit?.id,
          (resCb) => {
            if (resCb) {
              console.log("Rescb", resCb.state, resCb.message);
              if (Array.isArray(resCb)) {
                const dependentList = resCb.map((dep) => ({
                  dependentId: dep.dpid,
                  dependentVisitId: dep.dvid,
                }));
                setDependentsCount(dependentList.length);
                console.log("Dependents for patient:", dependentList);
                if (
                  dependentList.length > 0 &&
                  !(
                    visitList.visit.internalStatus === "MOVED_TO_BILLING" ||
                    visitList.visit.internalStatus === "INVOICE_GENERATED" ||
                    visitList.visit.internalStatus === "BILL_CLEARED"
                  )
                ) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              } else if (resCb.state === "error") {
                resolve(false);
              }
            } else {
              reject("No response from API");
            }
          }
        )
      );
      setVisitList(visitList);
    });
  };

  const KeepDependents = () => {
    var ServerResVal = ServerRes;
    console.log("keepdependent visitlist", visitList);
    let ptid = visitList.id;
    let vid = visitList.visit.id;
    let distdate = getDischargeDateTime();
    console.log(distdate);
    console.log("keepdependent visitlist with props", props.visitsList);
    let data = {};
    data["checkType"] = ERP_LABEL_INTERNAL_STATUS_MOVED_TO_BILLING;
    data["ptid"] = ptid;
    data["vid"] = vid;
    data["distdate"] = distdate;
    dispatch(
      patientActions.KeepDependents(data, (resCb) => {
        if (resCb) {
          console.log("Rescb", resCb.state, resCb.message);
          console.log("inside the keep dependent ");
          // if (resCb.state === "success") {
          //   ServerResVal.success = resCb.message;
          // } else if (resCb.state === "error") {
          //   ServerResVal.error = resCb.messages.message;

          // }
          // setServerRes({ ...ServerResVal });
          if (resCb.errorMessages) {
            ServerResVal.error = resCb.errorMessages;
            console.log("errormsg:", resCb.errorMessages);
            props.handleModelclose();
          } else if (resCb.successMessages) {
            ServerResVal.success =
              "Succesfully moved to billing and room assigned to dependent";
            console.log("successmsg:", ServerResVal.success);
            toggle();
            // props.onModalClose(visitList);
          }
          // toggle();
          setServerRes({ ...ServerResVal });

          setTimeout(() => {
            closeAlert();
            if (ServerResVal?.success) {
              props.onModalClose(visitList);
            }
          }, 3000);
          setOnModal(false);
        }
      })
    );
    setShowDependent(false);
  };

  const closeDependentModel = (event) => {
    props.handleModelclose();
    setShowDependent(false);
  };
  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const handleOnChange = (value, event) => {
    if (value === "date") {
      setSelecteddate(event.target.value);
      setDischargeDateSelect(false);
    }
    if (value === "time") {
      setSelectedTime(event.target.value);
      setDischargeDateSelect(false);
    }
  };

  const toggle = () => {
    setOnModal(false);
    setRoomDealocateModal(false);
    setDischargeDate("");
    setDischargeTime("");
    setShowDependent(false);
  };

  const closeModel = (event) => {
    setOnModal(false);
    setRoomDealocateModal(false);
    setDischargeDate("");
    setDischargeTime("");
    setShowDependent(false);
    if (props.handleModelclose) {
      props.handleModelclose();
    } else {
      props.onModalClose?.();
    }
    setServerRes({ success: "", error: "" });
  };

  const AlreadyMovedBill = (event) => {
    setOnModal(false);
    props.handleModelclose();
  };

  const updatePatientAadhar = (selectedPatient) => {
    const ServerResVal = { ...ServerRes };
    // const isAadharMasked =
    //   visitList?.maskAdhar === "" || visitList?.maskAdhar === undefined;
    // const isAadhar = visitList?.adhar === "" || visitList?.adhar === undefined;
    // const isInPatient = visitList?.visit?.type === "InPatient";
    // const isOutPatient = visitList?.visit?.type === "OutPatient";
    // const isAadharMandatory = org?.isAadharNumberMandatory?.forInpatients;

    // // Aadhaar validation and API call block
    // if (isAadharMasked && isAadhar) {
    //   // Aadhaar is required for InPatient
    //   if (
    //     isAadharMandatory &&
    //     isInPatient &&
    //     (!visitList?.adhar || visitList.adhar === "")
    //   ) {
    //     if (!aadharValue || aadharValue.trim() === "") {
    //       setAadharError("Please Enter Aadhaar Number");
    //       return false;
    //     }
    //     if (aadharValue.length !== 12) {
    //       setAadharError("Please Enter Valid Aadhaar Number");
    //       return false;
    //     }
    //     visitList.adhar = aadharValue;
    //     setAadharError("");
    //     visitList.checkAdharUpdate = "YES";
    //   }
    //   // Optional for OutPatient
    //   else if (isOutPatient) {
    //     if (aadharValue && aadharValue.length !== 12) {
    //       setAadharError("Please Enter Valid Aadhaar Number");
    //       return false;
    //     }
    //     if ((!visitList?.adhar || visitList.adhar === "") && aadharValue) {
    //       visitList.adhar = aadharValue;
    //       setAadharError("");
    //     }
    //   }
    const isAadharMasked =
      visitList?.maskAdhar === "" || visitList?.maskAdhar === undefined;
    const isAadhar = visitList?.adhar === "" || visitList?.adhar === undefined;

    // Aadhaar validation and API call block
    if (isAadharMasked && isAadhar) {
      // If Aadhaar is entered, validate it
      if (aadharValue && aadharValue.trim() !== "") {
        if (aadharValue.length !== 12) {
          setAadharError("Please Enter Valid Aadhaar Number");
          return false;
        }
        visitList.adhar = aadharValue;
        visitList.checkAdharUpdate = "YES";
        setAadharError("");
      } else {
        // Aadhaar not entered — just skip validation (not mandatory)
        setAadharError("");
        visitList.checkAdharUpdate = "NO";
      }
      setIsDisabled(true);
      dispatch(
        patientActions.updatePatientAdhaar(visitList, (resCb) => {
          if (!resCb) return;
          if (resCb.state === "success") {
            ServerResVal.success = resCb.message;
            const data = {
              patientId: visitList.visit.patientId,
              visitId: visitList.visit.id,
              dischargeDate: getDischargeDateTime(),
              checkType: ERP_LABEL_INTERNAL_STATUS_MOVED_TO_BILLING,
            };

            dispatchMoveToBill(data, visitList, ServerResVal);
          } else if (resCb.state === "error") {
            ServerResVal.error = resCb.messages.message;
            setServerRes({ ...ServerResVal });
            setTimeout(() => closeAlert(), 3000);
            setOnModal(false);
            setIsDisabled(false);
          }
        })
      );
    } else {
      // If Aadhaar is masked or not required, directly move to billing
      const data = {
        patientId: visitList.visit.patientId,
        visitId: visitList.visit.id,
        dischargeDate: getDischargeDateTime(),
        checkType: ERP_LABEL_INTERNAL_STATUS_MOVED_TO_BILLING,
      };
      setIsDisabled(true);
      dispatchMoveToBill(data, visitList, ServerResVal);
    }

    setOnModal(false);
  };

  const getDischargeDateTime = () => {
    const dateStr = dischargeDateSelect ? dischargeDate : selecteddate;
    const timeStr = dischargeDateSelect ? dischargeTime : selectedTime;

    // Ensure both parts exist
    if (!dateStr || !timeStr) return "";

    const formattedDateTime = `${dateStr}T${timeStr}:00`; // Example: 2025-07-31T19:34:00
    console.log("timestamp", formattedDateTime);

    return formattedDateTime;
  };

  const dispatchMoveToBill = (data, visitList, ServerResVal) => {
    dispatch(
      patientActions.erpV2moveToBill(data, (resCb) => {
        if (!resCb) return;

        if (resCb.errorMessages) {
          getPatientProfile();
          const errorMsg = resCb.errorMessages[0];

          if (
            errorMsg === "Redirecting to deallocate the room service" ||
            errorMsg === "Dependent exists please discharge them first"
          ) {
            ServerResVal.success = errorMsg;
          } else {
            ServerResVal.error = errorMsg;
          }

          if (resCb.count === 2) {
            setTimeout(() => setRoomDealocateModal(true), 3000);
          }

          if (resCb.count === 4) {
            setTimeout(() => {
              checkFordependent(visitList);
              setShowDependent(true);
            }, 3000);
          }
        } else if (resCb.successMessages) {
          ServerResVal.success = resCb.successMessages;
          toggle();
          props.onModalClose(visitList);
        }

        setServerRes({ ...ServerResVal });
        setTimeout(() => {
          closeAlert();
        }, 3000);
        setOnModal(false);
        setIsDisabled(false);
      })
    );
  };
  const getPatientProfile = () => {
    let patId = visitList.visit.patientId;
    dispatch(
      patientActions.getPatientProfile(patId, (resCb) => {
        if (resCb) {
          console.log("patientprofile", resCb);
        }
      })
    );
  };

  const roomDealocate = (event) => {
    var ServerResVal = ServerRes;
    console.log("submit method move to bill : ", visitList);
    let visitListDetails = { ...visitList };
    console.log("submit method move to bills : ", visitListDetails);
    let data = {};
    data["patientId"] = visitListDetails.visit.patientId;
    data["visitId"] = visitListDetails.visit.id;
    let dischargeDateTime = "";
    // if (type == "InPatient") {
    if (visitList?.visit?.type === "InPatient") {
      const dateStr = dischargeDateSelect ? dischargeDate : selecteddate;
      const timeStr = dischargeDateSelect ? dischargeTime : selectedTime;

      // Ensure both parts exist
      if (!dateStr || !timeStr) return "";

      dischargeDateTime = `${dateStr}T${timeStr}:00`; // Example: 2025-07-31T19:34:00

      console.log("timestamp", dischargeDateTime);
    }
    data["dischargeDate"] = dischargeDateTime;
    data["checkType"] = ERP_LABEL_INTERNAL_STATUS_MOVED_TO_BILLING;
    setIsDeallocating(true);
    dispatch(
      patientActions.roomDealocate(data, (resCb) => {
        if (resCb) {
          console.log("response of move to bill api:", resCb);
          if (resCb.errorMessages) {
            // ServerResVal.error = "Failed Move to biling";
            ServerResVal.error = resCb.errorMessages;
            console.log("errormsg:", resCb.errorMessages);
            props.handleModelclose();
          } else if (resCb.successMessages) {
            // ServerResVal.success = resCb.successMessages;
            // // ServerResVal.success = "Succesfully Moved to billing";
            // toggle();
            // console.log("successmsg:", ServerResVal.success);
            // props.onModalClose(visitList);
              ServerResVal.success = resCb.successMessages;
              getPatientProfile();

  // dispatch(
  //   patientActions.getPatientProfile(
  //     visitListDetails.visit.patientId,
  //     () => {}
  //   )
  // );

  toggle();
  props.onModalClose(visitList);
          }
          setServerRes({ ...ServerResVal });

          setTimeout(() => {
            closeAlert();
          }, 3000);
          setRoomDealocateModal(false);
        }
        setIsDeallocating(false);
      })
    );
  };

  const handleAadhaarChange = (event) => {
    const raw = event.target.value.replace(/\D/g, ""); // Keep only digits
    const val = raw.slice(0, 12); // Limit to 12 digits
    setAadharValue(val);
    if (val === "") {
      setAadharError(""); // Clear error when empty
    } else if (val.length < 12) {
      setAadharError(""); // Don't show error until user finishes typing
    } else if (val.length === 12) {
      setAadharError(""); // Valid Aadhaar
    }
  };

  return (
    <>
      <div className="m-2">
        {ServerRes.success && (
          <Alert severity="success" className="alert-div">
            {ServerRes.success}{" "}
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={(event) => closeAlert(event)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}
        {ServerRes.error && (
          <Alert severity="error" className="alert-div">
            {ServerRes.error}{" "}
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={(event) => closeAlert(event)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}
      </div>
      <Dialog
        open={onModal}
        onClose={closeModel}
        className="d-flex w-95 h-90 flex-column-reverse modalDialog"
      >
        <div>
          <DialogTitle>
            Warning!
            <IconButton
              aria-label="close"
              onClick={(event) => closeModel(event)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent className="billing">
            {visitList?.visit?.internalStatus &&
            ["MOVED_TO_BILLING", "INVOICE_GENERATED", "BILL_CLEARED"].includes(
              visitList.visit.internalStatus
            ) ? (
              <span>
                Patient {visitList.fname ? visitList.fname : ""} already has
                been sent for Billing. If you need to add/delete
                services/charges please do it in the Billing module.
              </span>
            ) : (
              <span>
                Are you sure you want to Move {visitList ? visitList.fname : ""}{" "}
                {visitList ? visitList.lname : ""} (
                {visitList ? visitList.id : ""}) to Billing?
              </span>
            )}
          </DialogContent>

          {/* <div className="mx-3">
            {(org?.isAadharNumberMandatory?.forInpatients &&
              visitList?.type === "InPatient" &&
              (!visitList?.maskAdhar || visitList?.maskAdhar === "")) ||
            (visitList?.type === "OutPatient" &&
              visitList?.internalStatus === "booked" &&
              (!visitList?.maskAdhar || visitList?.maskAdhar === "")) ? (
              <div style={{ marginTop: "8px" }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      className="p-2"
                      label="Aadhaar"
                      id="Aadhaar"
                      type="text"
                      inputProps={{
                        maxLength: 12,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        style: { whiteSpace: "nowrap" },
                      }}
                      value={aadharValue}
                      placeholder="000011112222"
                      autoComplete="off"
                      onChange={handleAadhaarChange}
                      error={!!aadharError}
                      helperText={
                        <span style={{ whiteSpace: "nowrap" }}>
                          {aadharError}
                        </span>
                      }
                      fullWidth
                      InputProps={{
                        style: { height: "35px" },
                      }}
                      FormHelperTextProps={{
                        style: { whiteSpace: "nowrap" },
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : null}
          </div> */}

          <div className="mx-3">
            {/* Show Aadhaar field only if it's not masked */}
            {(!visitList?.maskAdhar || visitList?.maskAdhar === "") && (
              <div style={{ marginTop: "8px" }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      className="p-2"
                      label="Aadhaar"
                      id="Aadhaar"
                      type="text"
                      inputProps={{
                        maxLength: 12,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        style: { whiteSpace: "nowrap" },
                      }}
                      value={aadharValue}
                      placeholder="000011112222"
                      autoComplete="off"
                      onChange={handleAadhaarChange}
                      error={!!aadharError}
                      helperText={
                        <span style={{ whiteSpace: "nowrap" }}>
                          {aadharError}
                        </span>
                      }
                      fullWidth
                      InputProps={{
                        style: { height: "35px" },
                      }}
                      FormHelperTextProps={{
                        style: { whiteSpace: "nowrap" },
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            )}
          </div>

          <DialogActions className="moveToBill">
            {visitList?.visit?.internalStatus &&
            ["MOVED_TO_BILLING", "INVOICE_GENERATED", "BILL_CLEARED"].includes(
              visitList.visit.internalStatus
            ) ? (
              <Button
                variant="contained"
                color="primary"
                className="btn-style bottomright"
                onClick={(event) => AlreadyMovedBill(event)}
                style={{ textTransform: "none" }}
              >
                Cancel
              </Button>
            ) : (
              <>
                <div
                  className="mx-3"
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {visitList?.visit?.type === "InPatient" && (
                    <div>
                      {console.log("dischargeDate", dischargeDate)}
                      {dischargeDate ? (
                        <label style={{ paddingTop: "5px" }}>
                          Patient has the Discharge Date {dischargeDate}{" "}
                          {dischargeTime}
                          <br />
                          Do you want to edit it?
                        </label>
                      ) : (
                        <label style={{ paddingTop: "5px" }}>
                          Select Discharge date:
                        </label>
                      )}
                      <div
                        className="d-flex pl-0 col-lg-7 col-xl-7 col-md-12 col-12"
                        style={{ gap: "12px" }}
                      >
                        <div>
                          <input
                            name="admissionDate"
                            id="admissionDate"
                            className="form-control filterin Quantity"
                            placeholder="Enter Scheduled Date"
                            required
                            type="date"
                            defaultValue={selecteddate}
                            onChange={(event) => handleOnChange("date", event)}
                          />
                        </div>
                        <div>
                          <input
                            name="admissionTime"
                            id="admissionTime"
                            className="form-control filterin Quantity"
                            placeholder="Enter Scheduled Time"
                            required
                            type="time"
                            defaultValue={selectedTime}
                            onChange={(event) => handleOnChange("time", event)}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingTop: "10px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      className="btn-style bottomright"
                      onClick={(event) => AlreadyMovedBill(event)}
                      style={{ textTransform: "none" }}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      className="btn-style bottomright"
                      onClick={handleMoveToBilling}
                      disabled={isDisabled}
                      style={{ textTransform: "none" }}
                    >
                      Move To Bill
                    </Button>
                  </div>
                </div>
              </>
            )}
          </DialogActions>
        </div>
      </Dialog>

      <Dialog
        open={showDependent}
        onClose={closeModel}
        className="d-flex w-95 h-90 flex-column-reverse modalDialog"
      >
        <div>
          <DialogTitle>
            Warning!
            <IconButton
              aria-label="close"
              onClick={(event) => closeModel(event)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogActions className="moveToBill">
            <>
              <div
                className="mx-3"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  {" "}
                  {console.log("dischargeDate", dischargeDate)}
                  {console.log("dependentMname", dependentMname)}
                  <label style={{ paddingTop: "5px" }}>
                    {dependentMname} have {dependentsCount} Dependents do you
                    want to keep them and discharge patient..
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: "10px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn-style bottomright"
                    onClick={(event) => closeDependentModel(event)}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  {console.log("inside model visitlist", visitList)}
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn-style bottomright"
                    onClick={KeepDependents}
                    style={{ textTransform: "none" }}
                  >
                    Keep Dependant(s)
                  </Button>
                </div>
              </div>
            </>
          </DialogActions>
        </div>
      </Dialog>

      <Dialog
        open={roomDealocateModal}
        onClose={closeModel}
        className="d-flex w-95 h-90 flex-column-reverse modalDialog"
      >
        <div>
          <DialogTitle>
            Warning!
            <IconButton
              aria-label="close"
              onClick={(event) => closeModel(event)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          {/* <DialogContent className="dealocate">
            <span>
              {" "}
              Are you sure you want Deallocate the room and move to Billing?
            </span>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              className="btn-style bottomright"
              onClick={(event) => roomDealocate(event)}
              disabled={isDeallocating}
              style={{ textTransform: "none" }}
            >
              Deallocate room and Move to Bill
            </Button>
          </DialogActions> */}

          <DialogContent className="dealocate">
  <span>
    {props.openRoomDealocate
      ? "Are you sure you want Deallocate the room"
      : "Are you sure you want Deallocate the room and move to Billing?"}
  </span>
</DialogContent>

<DialogActions>
  <Button
    variant="contained"
    color="primary"
    className="btn-style bottomright"
    onClick={(event) => roomDealocate(event)}
    disabled={isDeallocating}
    style={{ textTransform: "none" }}
  >
    {props.openRoomDealocate
      ? "Deallocate room"
      : "Deallocate room and Move to Bill"}
  </Button>
</DialogActions>
        </div>
      </Dialog>
    </>
  );
}

export default MoveToBilling;
